export default "__VITE_ASSET__Bl32VPjx__"